<template>
  <div class="CreatvallStyle">
    <div class="title" ref="creatInnerHtmlTitle">创建录播</div>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="80px" class="CreatVhallForm">
      <el-form-item label="录播标题" prop="subject">
        <el-input v-model="ruleForm.subject"></el-input>
      </el-form-item>
      <el-form-item label="录播简介" prop="desc">
        <el-input type="textarea" v-model="ruleForm.introduction"></el-input>
      </el-form-item>
      <el-form-item label="录播视频Url">
        <el-input v-model="ruleForm.playUrl"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" ref="creatInnerHtml">立即创建</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { createRecord, updateRecord } from '@/api/VhallLive'
  export default {
    name: 'CreatVhall',
    data() {
      return {
        rules: {
          subject: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
          ]
        },
        ruleForm: {
          subject: '',
          player: 2,
          playUrl: '',
          introduction: '',
          webinarId: ''
        }
      }
    },
    creat() {
    },
    watch: {},
    mounted() {
      // 修改录播
    //   console.log(this.$route.params.item)
      if (this.$route.params.item) {
        // console.log(this.$route.params.item)
        this.$refs.creatInnerHtmlTitle.innerHTML = '编辑'
        this.$refs.creatInnerHtml.$el.innerText = '保存'
        this.ruleForm.subject = this.$route.params.item.subject
        this.ruleForm.playUrl = this.$route.params.item.playUrl
        this.ruleForm.introduction = this.$route.params.item.introduction
        this.ruleForm.webinarId = this.$route.params.item.webinarId
      }
    },
    methods: {
      // 添加页面
      apiSend() {
        var obj = {
          subject: this.ruleForm.subject,
          introduction: this.ruleForm.introduction,
          player: this.ruleForm.player,
          playUrl: this.ruleForm.playUrl
        }
        createRecord(obj).then(response => {
        //   console.log(response.data)
          if (response.data) {
            this.$message({
              message: '页面添加成功',
              type: 'success'
            })
            this.$router.push({ name: 'Livelist' })
          }
        })
      },
      // 修改页面
      apiSendUpdate() {
        var obj = {
          subject: this.ruleForm.subject,
          introduction: this.ruleForm.introduction,
          player: this.ruleForm.player,
          playUrl: this.ruleForm.playUrl,
          webinarId: this.ruleForm.webinarId
        }
        updateRecord(obj).then(response => {
        //   console.log(response.data)
          if (response.data) {
            this.$message({
              message: response.msg,
              type: 'success'
            })
            this.$router.push({ name: 'Livelist' })
          }
        })
      },
      onSubmit() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if (this.$route.params.item) {
              this.apiSendUpdate()
            } else {
              this.apiSend()
            }
          } else {
            console.log('error submit!!')
            return false;
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .CreatvallStyle {}

  .title {
    font-size: 20px;
    padding: 15px 0px 0px 15px;
  }

  .CreatVhallForm {
    width: 500px;
    margin-top: 50px;
  }


  /* 直播 */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 300px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px dotted;
  }

  .avatar {
    width: 300px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/Live-Platform/creat-lubo.vue